export default class Customer {
    uid = ""
    username = ""
    email = ""
    telephone = ""
}